import baseDayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

baseDayjs.extend(timezone)
baseDayjs.extend(utc)

// Use browser's timezone instead of UTC
baseDayjs.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone)

export const dayjs = baseDayjs
